import { IconBrandThreejs } from "@tabler/icons-react";
import {
  FaJs,
  FaReact,
  FaNodeJs,
  FaDatabase,
  FaHtml5,
  FaCss3,
  FaAngular,
  FaVuejs,
  FaLanguage,
  FaBrain,
  FaTags,
  FaCubes,
} from "react-icons/fa";
import {
  SiTypescript,
  SiPocketbase,
  SiMongodb,
  SiMysql,
  SiBlazor,
  SiSpringboot,
  SiCsharp,
  SiBmcsoftware,
  SiWebcomponentsdotorg,
  Si365Datascience,
} from "react-icons/si";

export const skillIcons: Record<string, JSX.Element> = {
  JavaScript: <FaJs />,
  React: <FaReact />,
  TypeScript: <SiTypescript />,
  "Node.js": <FaNodeJs />,
  SQL: <FaDatabase />,
  HTML: <FaHtml5 />,
  CSS: <FaCss3 />,
  PocketBase: <SiPocketbase />,
  MongoDB: <SiMongodb />,
  MySQL: <SiMysql />,
  Angular: <FaAngular />,
  Vue: <FaVuejs />,
  Blazor: <SiBlazor />,
  "Three.Js": <IconBrandThreejs />,
  "Spring Boot": <SiSpringboot />,
  "C# Web Api": <SiCsharp></SiCsharp>,
  "Software engineering": <SiBmcsoftware></SiBmcsoftware>,
  "Web programming": <SiWebcomponentsdotorg></SiWebcomponentsdotorg>,
  "Expertise in applied computer science": (
    <Si365Datascience></Si365Datascience>
  ),
  "Natural Language Processing": <FaLanguage />,
  "Large Language Model": <FaBrain></FaBrain>,
  "Named Entity Recognition": <FaTags></FaTags>,
  Microservice: <FaCubes></FaCubes>,
};
